import { action } from 'mobx';
import { RouterState, RedirectFunction } from 'react-router';
import { AccountCouponsPageModel } from './model';
import { APIController } from '../../api/controller';
import { UserModel } from '../../user/model';
import { BugsnagController } from '../../bugsnag/controller';
import { UIController } from '../../ui/controller';
import { EnvModel } from '../../env/model';
import { StorageModel } from '../../storage/model';

export class AccountCouponsPageController {
  constructor(
    private model: AccountCouponsPageModel,
    private user: UserModel,
    private api: APIController,
    private bugsnag: BugsnagController,
    private ui: UIController,
    private env: EnvModel,
    private storage: StorageModel
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    await this.ui.setSEO(nextState.location.pathname);

    this.ui.setBreadcrumbs([
      {
        path: '/account',
        label: 'Account',
      },
      {
        path: '/account/coupons',
        label: 'Coupons',
      },
    ]);

    return;
  };

  @action
  hideCreditInfoBox = (): void => {
    this.storage.setItem('hideAccountCreditInfoBox', true);
  };
}
